import { render, staticRenderFns } from "./SelectedProductDialog.vue?vue&type=template&id=5006b87a&scoped=true"
import script from "./SelectedProductDialog.vue?vue&type=script&lang=js"
export * from "./SelectedProductDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5006b87a",
  null
  
)

export default component.exports